export class OptionItem<T> {
    constructor(
        public value: T,
        public label = '',
    ) {}
}
